import { call, put } from 'redux-saga/effects';
import { Messages, Formatters } from '../../../../codegen/Localize';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { requestFailed } from '../../../actions/RequestFailedAction';
import { requestSpaceContents } from '../../../actions/spaces/RequestSpaceContentsActions';
import { SetDataQualityTriggerAction } from '../../../actions/spaces/SetDataQualityTriggerAction';
import { reloadSpaceIfUpdatingCurrentSpace } from './RefreshContentSagas';
import {
  callViaApiService as getDataQualityTriggersForItem,
  DataQualityTriggerInfo,
  GetDataQualityTriggersForItemResponse
} from '../../../../ts/restApi/dataQualityTriggers/getDataQualityTriggersForItem';
import { callViaApiService as setDataQualityTriggersForItem } from '../../../../ts/restApi/dataQualityTriggers/setDataQualityTriggersForItem';
import { openReactActionDialog } from '../../../../commonInfra/dialogs/ReactActionDialog';
import { defaultInitialState, DataQualityTriggerDialogState, getDataQualityTriggerActionDialogOptions } from '../../../quality/DataQualityTriggerDialog';
import { ToasterService, ToastType } from '../../../../ts/services/ToasterService';

export function* handleSetDataQualityTrigger(action: SetDataQualityTriggerAction) {
  try {

    const existingTriggerResponse: GetDataQualityTriggersForItemResponse = yield call(
      getDataQualityTriggersForItem,
      {
        contentItemType: action.item.contentType,
        contentItemLuid: action.item.luid,
      }
    );

    yield call(
      openDataQualityTriggerDialog,
      action.item,
      existingTriggerResponse.dataQualityTriggerList.dataQualityTrigger[0] ?? undefined,
    );

    const maybeReloaded = yield call(reloadSpaceIfUpdatingCurrentSpace, [action.item]);
    if (!maybeReloaded) {
      yield put(requestSpaceContents());
    }

  } catch(e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}


export function openDataQualityTriggerDialog(item: IContentInfo, existingTrigger: DataQualityTriggerInfo | undefined): PromiseLike<unknown> {

  async function makeApiCallAndDisplayResult(formData: DataQualityTriggerDialogState) {
    const toaster = ToasterService.instance;
    try {
      await setDataQualityTriggersForItem({
        contentItemType: item.contentType,
        contentItemLuid: item.luid,
        dataQualityTrigger: {
          type: getDQType(item.contentType),
          message: formData.message,
          active: formData.enableTrigger,
          severe: formData.isSevere,
        }
      });

      const itemCount = 1;
      const successMessage = formData.enableTrigger
        ? Messages.dataQualityTrigger_EnableSuccess({ COUNT: itemCount, COUNT_LOC: Formatters.formatCount(itemCount) })
        : Messages.dataQualityTrigger_DisableSuccess({ COUNT: itemCount, COUNT_LOC: Formatters.formatCount(itemCount) });
      toaster.pop({
        type: ToastType.Info,
        text: successMessage,
      });

    } catch {
      toaster.pop({
        type: ToastType.Error,
        text: getToasterErrorText(item.contentType),
      });
    }
  }

  const modalInstance = openReactActionDialog(getDataQualityTriggerActionDialogOptions({
    initialBodyProps: { contentName: item.name, contentType: getCorrectContentType(item.contentType)},
    initialFormData: existingTrigger ? getFormDataFromTrigger(existingTrigger) : defaultInitialState,
    doAction: makeApiCallAndDisplayResult,
  }));
  return modalInstance.result;
}

function getFormDataFromTrigger(trigger: DataQualityTriggerInfo): DataQualityTriggerDialogState {
  return {
    enableTrigger: trigger.active,
    isSevere: trigger.severe,
    message: trigger.message,
  };
}

function getDQType(contentType: string) {
  if (contentType === 'datasource') {
    return 'extract_refresh';
  } else {
    return 'flow_run';
  }
}

function getToasterErrorText(contentType: string) {
  if (contentType === 'datasource') {
    return Messages.dataQualityTrigger_Error_Datasource();
  } else {
    return Messages.dataQualityTrigger_Error_Flow();
  }
}

function getCorrectContentType(contentType: string) {
  if (contentType === 'datasource') {
    return 'datasource';
  } else {
    return 'flow';
  }
}
